import { Box, Button, Title, Group, Text, Stack, Paper, Flex, useMantineTheme } from "@mantine/core";
import { accentDividerStyle, filledCtaButtonProps, leftAccentCardProps } from "@canucci/base-mantine/theme";
import { LuRefreshCw } from "react-icons/lu";
import { useTranslation } from "react-i18next";

interface InsightsWaitingStateProps {
  onRefresh: () => void;
  loading: boolean;
}

function InsightsWaitingState({ onRefresh, loading }: InsightsWaitingStateProps) {
  const { t: tPages } = useTranslation("pages");
  const theme = useMantineTheme();
  const { sizes } = theme.other;
  return (
    <Flex mih="100%" align="center" justify="center" py={{ base: "xl", md: "3xl" }}>
      <Box maw={sizes.maxPageWidthDesktop} mx="auto" px={{ base: "md", md: "xl" }} ta="center">
        <Stack gap="md" align="center">
          <Title size="h1" c="var(--text-on-dark)">
            {tPages("canvas.insights.title")}
          </Title>
          <Box style={accentDividerStyle} />
          <Paper {...leftAccentCardProps} p="xl" maw="28rem">
            <Stack gap="md">
              <Text fz="md" c="var(--text-on-dark)">
                {tPages("canvas.insights.resultsComingSoon")}
              </Text>
              <Text fz="sm" c="var(--text-on-dark-muted)">
                {tPages("canvas.insights.resultsComingSoonDescription")}
              </Text>
              <Button {...filledCtaButtonProps("primary")} onClick={onRefresh} loading={loading}>
                <Group gap="xs">
                  <LuRefreshCw />
                  <Text fz="sm">{tPages("canvas.insights.refresh")}</Text>
                </Group>
              </Button>
            </Stack>
          </Paper>
        </Stack>
      </Box>
    </Flex>
  );
}

export default InsightsWaitingState;
